import { render, staticRenderFns } from "./TheoryPracticeWorkshopsManagement.vue?vue&type=template&id=e7865a82&scoped=true&"
import script from "./TheoryPracticeWorkshopsManagement.vue?vue&type=script&lang=js&"
export * from "./TheoryPracticeWorkshopsManagement.vue?vue&type=script&lang=js&"
import style0 from "./TheoryPracticeWorkshopsManagement.vue?vue&type=style&index=0&id=e7865a82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7865a82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAlert,VBtn,VCard,VCardTitle,VDataTable,VSpacer,VTextField,VTooltip})
